angular
  .module('quote')

  .factory('QuoteAssingPmRequest', [
    'Crud',

    function(Crud) {
      'use strict';

      class QuoteAssingPmRequest extends Crud {
        constructor() {
          super(null, '@@apiUrl' + '/assign-pm/:id', { id: '@id' });
        }
      }

      return QuoteAssingPmRequest;
    }
  ]);
